import { render, staticRenderFns } from "./tablePhone.vue?vue&type=template&id=fb6b4094"
import script from "./tablePhone.vue?vue&type=script&lang=js"
export * from "./tablePhone.vue?vue&type=script&lang=js"
import style0 from "./tablePhone.vue?vue&type=style&index=0&id=fb6b4094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports